import { render } from "./HelpCenterArticleFull.vue?vue&type=template&id=985ad97a&ts=true"
import script from "./HelpCenterArticleFull.vue?vue&type=script&lang=ts"
export * from "./HelpCenterArticleFull.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__